import React, { Component, PropTypes } from 'react';
import { TaskActions } from 'actions';
import { GridContainer, GridRow, GridCell } from 'components/Grid';
import FilterList from './FilterList';
import { Units } from 'Css';
import { Toggle, IconButton } from 'material-ui';
import * as Icons from 'components/Material/SvgIcons';

const css = oxygenCss({
  root: {
    position: 'relative'
  },
  filter: {
    padding: `${Units.base * 2}px ${Units.base}px`
  },
  filterToggle: {
    textAlign: 'right'
  }
});

class FilterBar extends Component {
  static propTypes = {
    tasksFilter: PropTypes.object,
    studentsFilter: PropTypes.string,
    coursesFilter: PropTypes.string,
    groupsFilter: PropTypes.string,
    studentsLoading: PropTypes.bool,
    coursesLoading: PropTypes.bool,
    groupsLoading: PropTypes.bool,
    students: PropTypes.array,
    courses: PropTypes.array,
    groups: PropTypes.array,
    mode: PropTypes.string
  };

  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  _handleCorrected = event => {
    const { checked: corrected } = event.target;
    TaskActions.setTaskFilter({ corrected });
  };

  _handleFilterChange = (listName, filter) => {
    if (listName === 'students') {
      TaskActions.setStudentFilter(filter);
    } else if (listName === 'courses') {
      TaskActions.setCourseFilter(filter);
    } else if (listName === 'groups') {
      TaskActions.setGroupFilter(filter);
    }
  };

  _handleTaskFilterChange = (listName, list) => {
    TaskActions.setTaskFilter({
      [listName]: list
    });
  };

  toggleMode = () => {
    TaskActions.toggleFilterMode();
  };

  render() {
    const { getIntlMessage } = this.context;
    const {
      tasksFilter,
      students,
      courses,
      groups,
      studentsFilter,
      coursesFilter,
      groupsFilter,
      studentsLoading,
      coursesLoading,
      groupsLoading,
      mode
    } = this.props;
    const simple = mode === 'simple';
    const switchIcon = simple ? (
      <Icons.HardwareKeyboardArrowDown />
    ) : (
      <Icons.HardwareKeyboardArrowUp />
    );

    return (
      <div className={css.root}>
        <GridContainer fluid>
          <GridRow>
            <GridCell size={4} xSmallSize={12} />
            <GridCell size={4} xSmallSize={12}>
              <div className={css.filter}>
                <Toggle
                  toggled={tasksFilter.corrected}
                  label={getIntlMessage('tasks.corrected')}
                  onToggle={this._handleCorrected}
                />
              </div>
            </GridCell>
            <GridCell size={4} xSmallSize={12}>
              <div className={css.filterToggle}>
                <IconButton touch onTouchTap={this.toggleMode}>
                  {switchIcon}
                </IconButton>
              </div>
            </GridCell>
          </GridRow>
          <GridRow>
            <GridCell size={4} xSmallSize={12}>
              <FilterList
                mini={simple}
                title={getIntlMessage('tasks.students')}
                list={students}
                loading={studentsLoading}
                filter={studentsFilter}
                onFilterChange={this._handleFilterChange.bind(this, 'students')}
                onChange={this._handleTaskFilterChange.bind(this, 'students')}
                selected={tasksFilter.students}
              />
            </GridCell>
            <GridCell size={4} xSmallSize={12}>
              <FilterList
                mini={simple}
                title={getIntlMessage('tasks.courses')}
                list={courses}
                loading={coursesLoading}
                filter={coursesFilter}
                onFilterChange={this._handleFilterChange.bind(this, 'courses')}
                onChange={this._handleTaskFilterChange.bind(this, 'courses')}
                selected={tasksFilter.courses}
              />
            </GridCell>
            <GridCell size={4} xSmallSize={12}>
              <FilterList
                mini={simple}
                title={getIntlMessage('tasks.groups')}
                list={groups}
                loading={groupsLoading}
                filter={groupsFilter}
                onFilterChange={this._handleFilterChange.bind(this, 'groups')}
                onChange={this._handleTaskFilterChange.bind(this, 'groups')}
                selected={tasksFilter.groups}
              />
            </GridCell>
          </GridRow>
        </GridContainer>
      </div>
    );
  }
}

export default FilterBar;



// WEBPACK FOOTER //
// ./src/js/components/Tasks/FilterBar.js